"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Doughnut", {
  enumerable: true,
  get: function get() {
    return _doughnut["default"];
  }
});
Object.defineProperty(exports, "PreviewDoughnut", {
  enumerable: true,
  get: function get() {
    return _previewDoughnut["default"];
  }
});
var _doughnut = _interopRequireDefault(require("./doughnut"));
var _previewDoughnut = _interopRequireDefault(require("./previewDoughnut"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }